import React from "react";
import { Button, Wrap, WrapItem } from "@chakra-ui/react";
import { useCustomTheme } from "../../../contexts/CustomThemeContext";

const cardsBorderRadii ="8px";


type Status =
    | "all"
    | "pending"
    | "awaiting_owner_approval"
    | "approved"
    | "declined"
    | "paid"
    | "active"
    | "completed"
    | "cancelled"
    | "refunded";

const OPTIONS: { key: Status; label: string; }[] = [
    { key: "all", label: "All" },
    { key: "awaiting_owner_approval", label: "Needs Review" },
    { key: "approved", label: "Approved" },
    { key: "paid", label: "Paid" },
    { key: "active", label: "Active" },
    { key: "completed", label: "Completed" },
    { key: "declined", label: "Declined" },
    { key: "cancelled", label: "Cancelled" },
    { key: "refunded", label: "Refunded" },
];

export default function StatusFilterChips({
    value,
    onChange,
}: {
    value: Status;
    onChange: (v: Status) => void;
}) {
    const { theme } = useCustomTheme();

    return (
        <Wrap spacing={2}>
            {OPTIONS.map((o) => {
                const isActive = value === o.key;

                return (
                    <WrapItem key={o.key}>
                        <Button
                            size="sm"
                            variant={isActive ? "solid" : "outline"}
                            bg={isActive ? theme.primary : theme.surface}
                            color={isActive ? theme.textOnPrimary : theme.text}
                            borderColor={isActive ? theme.primary : theme.borderStrong}
                            boxShadow={isActive ? theme.shadowSm : "none"}
                            _hover={{
                                opacity: 0.95,
                                bg: isActive ? theme.primaryHover : theme.hover,
                                borderColor: isActive ? theme.primaryHover : theme.inputBorderFocus,
                            }}
                            _active={{ opacity: 0.9 }}
                            borderRadius={cardsBorderRadii}
                            fontWeight="600"
                            onClick={() => onChange(o.key)}
                        >
                            {o.label}
                        </Button>
                    </WrapItem>
                );
            })}
        </Wrap>
    );
}